module.exports = __webpack_public_path__ + "static/media/image4.bfe2960b.png";